
export default function ValidationsTipo() {

    const validateFields = (fields) => {
        const {
            servico,
            tipo,
            descricao,
        } = fields;
        const errors = {};

        if (!servico || !servico.value) {
            errors.servico = "Pelo menos um serviço deve ser selecionado.";
        }
        if (!tipo.trim()) errors.tipo = "O campo Tipo é obrigatório.";
        if (!descricao.trim()) errors.descricao = "O campo Descrição é obrigatório.";
       
        return errors;
    };

    return {
        validateFields
    }
}